module.exports = __webpack_public_path__ + "static/001-c8dadadda0d0f71ff90881d6b617fd7e.jpg";